import {Injectable} from '@angular/core';
import {Http, Response} from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import {HttpService} from './http.service';

class User {
  username: string;
  password: string;
}

@Injectable()
export class AuthenticationService {

  constructor(private httpService: HttpService, private http: Http) {
  }

  login(username: string, password: string) {
    return this.httpService.postData('rest/' + localStorage.getItem('organizationAlias') + '/login',
      JSON.stringify({username: username, password: password}))
      .then(res => {
        // console.log("Res in login ", res);
        /*Если старый юзер пытается залогиниться - вернется пустой токен
         * т.к. юзер еще не зарегистрирован, поэтому не нужно его сохранять
         */

        if(!res.isOldUser){
          localStorage.setItem("token", res.token);
        }
        this.extractData(res);
        return res;
      });
  }

  logout() {
    const token = localStorage.getItem("token");
    if (token != null) {
      this.httpService.postDataWithAuth('rest/logout', null);
      localStorage.removeItem("token");
    }

    const userToWatch = JSON.parse(localStorage.getItem('userToWatchFrom'));

    if(userToWatch == null) {
      localStorage.removeItem('currentUser');
    }

    localStorage.removeItem('userToWatchFrom');
  }

  private extractData(res: Response) {
    const body = res;
    localStorage.setItem('currentUser', JSON.stringify(body));
    return body || {};
  }
}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/_service/authentication.service.ts